import React, {ReactNode} from 'react';
import classNames from 'clsx';
import {Spinner} from '../spinner/spinner';

export type DrawerProps = {
    show: boolean;
    onCloseRequest: () => void;
    id?: string;
    className?: string;
    headerCbMobile?: (props: DrawerProps) => ReactNode;
    headerCbDesktop?: (props: DrawerProps) => ReactNode;
    contentCb?: (props: DrawerProps) => ReactNode;
    contentLoading?: boolean;
};

/**
 * when styling: use drawer-mobile and drawer-desktop mixins from common styles
 */
export const HibuDrawer = React.memo((props: DrawerProps) => {
    const {show, id, className, headerCbDesktop, headerCbMobile, contentCb, contentLoading} = props;
    return (
        <div className={classNames('hibu-drawer', className, show ? 'active' : 'inactive')} id={id}>
            <ContentLoader contentLoading={!!contentLoading} />
            {headerCbDesktop && <div className={'hibu-drawer-header desktop'}>{headerCbDesktop(props)}</div>}
            {headerCbMobile && <div className={'hibu-drawer-header mobile'}>{headerCbMobile(props)}</div>}

            {contentCb && <div className={'hibu-drawer-content'}>{contentCb(props)}</div>}
        </div>
    );
});

interface ContentLoaderProps {
    contentLoading: boolean;
}

const ContentLoader = React.memo(({contentLoading}: ContentLoaderProps) => {
    if (!contentLoading) {
        return null;
    }
    return (
        <div className={'hibu-content-loader'}>
            <Spinner />
        </div>
    );
});
